import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getSupports } from "../api/ApiRoutesFile";

export const supportApiSlice = createApi({
  reducerPath: "supportApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://castle-auction-production.up.railway.app/api/",
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      const token = localStorage.getItem("auction_portal");
      if (token) {
        headers.set("x-auth-token", token);
      }
      return headers;
    },
  }),
  tagTypes: ["Supports"],
  endpoints: (builder) => ({
    // Change to match how you're querying the data
    support: builder.query({
      query: ({ endpoint, id }) => {
        const url = id ? `${endpoint}${id}` : endpoint;
        return {
          url,
          method: "GET",
        };
      },
      providesTags: (result) =>
        result
          ? [
              ...result.Messages.map(({ _id }) => ({
                type: "Supports",
                id: _id,
              })),
              { type: "Supports", id: "LIST" },
            ]
          : [{ type: "Supports", id: "LIST" }],
    }),

    updateSupport: builder.mutation({
      query: ({ endpoint, id, formData }) => ({
        url: `${endpoint}/${id}`,
        method: "PUT",
        body: formData,
      }),
      // Fix the optimistic update
      async onQueryStarted(
        { endpoint, id, formData, lastId },
        { dispatch, queryFulfilled }
      ) {
        try {
          const { data } = await queryFulfilled;
          if (data && data.service) {
            dispatch(
              supportApiSlice.util.updateQueryData(
                "support",
                { endpoint: getSupports, id: lastId },
                (draft) => {
                  if (draft && draft.Messages) {
                    const supportIndex = draft.Messages.findIndex(
                      (item) => item._id === id
                    );
                    if (supportIndex !== -1) {
                      draft.Messages[supportIndex] = data.service;
                    }
                  }
                }
              )
            );
          }
        } catch (error) {
          console.error("Update Support failed:", error);
        }
      },
    }),
  }),
});

export const {
  useSupportQuery, // This should match your query name
  useUpdateSupportMutation,
} = supportApiSlice;
